import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Add a small delay to ensure the page has rendered
    const scrollTimer = setTimeout(() => {
      // Smooth scroll to top when page changes
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 100); // 100ms delay for better UX

    // Cleanup timer
    return () => clearTimeout(scrollTimer);
  }, [pathname]);

  return null;
};